module.exports = __webpack_public_path__ + "static/img/icon_app.87a65ce8.png";